// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import IconStyle from "./IconStyle";
import dashboardIcon from "../../../icons/dashboard.png";
import InsightsIcon from "@mui/icons-material/Insights";
import PersonIcon from "@mui/icons-material/Person";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import HealthAndSafetySharpIcon from "@mui/icons-material/HealthAndSafetySharp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import PeopleIcon from "@mui/icons-material/People";
import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext";
import HouseIcon from "@mui/icons-material/House";
import { Chat, ExploreOutlined } from "@mui/icons-material";
import BadgeIcon from "@mui/icons-material/Badge";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import MedicalInformationOutlinedIcon from "@mui/icons-material/MedicalInformationOutlined";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { BatchPrediction } from "@mui/icons-material";
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const getIconn = (names) => (
  <IconStyle src={`../../../icons/${names}.png`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIconn("dashboard"),
  //   dashboard: getIcon("ic_dashboard"),
  patientregistration: getIconn("add-user"),
  insurance: getIconn("healthcare"),
  //report icon added
  reportissue: getIcon("ic_reportissue"),
  patients: getIconn("epilepsy"),
  patientmonitoring: getIconn("monitoring"),
  pendingforms: getIconn("file"),
  allpatientvitals: getIconn("vital-signs"),
  hamp: getIconn("migraine"),
  appointments: getIconn("schedule"),
  careplan: getIconn("medical-record"),
  departments: getIconn("structure"),
  doctors: getIconn("doctor-visit"),
  user: getIconn("people"),
  forms: getIconn("form"),
  email: getIconn("email"),
  setting: getIconn("setting"),
  webcms: getIconn("website-creator"),
  blog: getIconn("online"),
  myhealthrecord: getIconn("project"),
  myprofile: getIconn("account"),
  validation: getIconn("approval"),
  programs: getIconn("wellness"),
  analytics: getIconn("chart-kz"),

  // removeappointments: getIcon("ic_removeappointments"),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      {
        title: "Dashboard",
        path: "/dashboard/maindashboard",
        //         icon: <HouseIcon />,
        icon: <HouseIcon />,
      },
      {
        title: "Provider Dashboard",
        path: "/dashboard/doctordashboard",
        icon: <HouseIcon />,
      },
      {
        title: "Insurance Dashboard",
        path: "/dashboard/insurancedashboard",
        icon: <HouseIcon />,
      },
      {
        title: "Kaizen Explore",
        path: "/dashboard/kaizen-xplore",
        icon: <ExploreOutlined />,
      },
      {
        title: "ADHD CDSS",
        path: "/dashboard/cdss",
        icon: <GraphicEqIcon />,
      },
      {
        title: "TBI CDSS",
        path: "/dashboard/tbi",
        icon: <PsychologyIcon />,
      },
      {
        title: "Headache CDSS",
        path: "/dashboard/headache-cdss",
        icon: <PsychologyIcon />,
      },
      {
        title: "Memory CDSS",
        path: "/dashboard/memory-cdss",
        icon: <PsychologyIcon />,
      },
      // {
      //   title: "Chat",
      //   path: "/dashboard/chat",
      //   icon: <Chat />,
      // },
      {
        title: "Concussion Prediction",
        path: "/dashboard/concussion-prediction",
        icon: <BatchPrediction />,
      },
      {
        title: "My Dashboard",
        path: "/dashboard/patientdashboard",
        icon: <HouseIcon />,
      },
      {
        title: "Patient Registration",
        path: "/dashboard/patientregistration",
        //         icon: ICONS.patientregistration,
        icon: <PersonAddAltOutlinedIcon />,
        //
      },
      {
        title: "Insurance",
        path: "/dashboard/insurance",
        //         icon: ICONS.insurance,
        icon: <HealthAndSafetySharpIcon />,
      },
      {
        title: "Patient Forms",
        path: "/dashboard/patientmonitoring",
        // icon: ICONS.patients,
        icon: <MedicalInformationOutlinedIcon />,
        children: [
          {
            title: "Patients",
            path: "/dashboard/patients",
          },
          {
            title: "Completed Forms",
            path: "/dashboard/patientmonitoring/tmphistory",
          },
          {
            title: "Assign Forms - Patient",
            path: "/dashboard/patientmonitoring/questionnairesassignment",
          },
          {
            title: "Pending Forms-Count",
            path: "/dashboard/pendingforms",
          },
          {
            title: "Pending Forms",
            path: "/dashboard/patientmonitoring/tmpquestionnaires",
          },
        ],
      },

      //Report Issue Added
      // {
      //   title: "Report Issue",
      //   path: "/dashboard/report-issue",
      //   icon: <ReportProblemIcon />,
      // },

      {
        title: "Assign Program to Patient",
        path: "/dashboard/programs",
        //         icon: ICONS.myhealthrecord,
        icon: <QueuePlayNextIcon />,
      },
      {
        title: "Activity Log",
        path: "/dashboard/activitylog",
        // icon: ICONS1.validation
        icon: <AssignmentTurnedInOutlinedIcon />,
      },
      {
        title: "My Patients",
        path: "/dashboard/mypatients",
        //         icon: ICONS.patients
        icon: <PeopleIcon />,
      },
      {
        title: "KCP",
        path: "/dashboard/patientmonitoring/tmpgraph",
        // icon: ICONS.analytics
        icon: <InsightsIcon />,
      },
      {
        title: "TMS",
        path: "/dashboard/patientmonitoring/trmgraph",
        // icon: ICONS.analytics
        icon: <InsightsIcon />,
      },
      {
        title: "KHP",
        path: "/dashboard/patientmonitoring/khpgraph",
        icon: <InsightsIcon />,
      },
      {
        title: "ADHD Program",
        path: "/dashboard/patientmonitoring/adhdgraph",
        icon: <InsightsIcon />,
      },
      {
        title: "SAINT Program",
        path: "/dashboard/patientmonitoring/saintgraph",
        icon: <InsightsIcon />,
      },
      {
        title: "KCMP",
        path: "/dashboard/patientmonitoring/kmpgraph",
        icon: <InsightsIcon />,
      },
      //       {
      //         title: "Pending Forms",
      //         path: "/dashboard/pendingforms",
      // //         icon: ICONS.pendingforms,
      // icon: <AssignmentLateIcon />,
      //       },
      {
        title: "All Patient vitals",
        path: "/dashboard/allpatientvitals",
        icon: <MonitorHeartOutlinedIcon />,
      },
      // {
      //              title: "Hamp View",
      //              path: "/dashboard/hamp/view",
      //              icon: ICONS.hamp,
      //            },
      {
        title: "Patient vitals",
        path: "/dashboard/patientvitals",
        icon: <MonitorHeartOutlinedIcon />,
      },
      {
        title: "Departments",
        path: "/dashboard/departments",
        //         icon: ICONS.departments,
        icon: <HubOutlinedIcon />,
      },
      {
        title: "Providers",
        path: "/dashboard/doctors",
        // icon: ICONS.doctors
        icon: <PeopleIcon />,
      },
      {
        title: "User",
        path: "/dashboard/user",
        //         icon: ICONS.user,
        icon: <PersonIcon />,
        children: [
          { title: "Users", path: "/dashboard/user/users" },
          {
            title: "List Of Passwords",
            path: "/dashboard/user/listofpassword",
          },
          { title: "User Role", path: "/dashboard/user/userrole" },
        ],
      },
      {
        title: "Diagnostic Reports",
        path: "/dashboard/patientmonitoring",
        // icon: ICONS.patientmonitoring,
        icon: <FileUploadOutlinedIcon />,

        children: [
          {
            title: "Diagnostic Reports - Upload",
            path: "/dashboard/patientmonitoring/diagnosticreports",
          },
          {
            title: "Diagnostic Reports - View",
            path: "/dashboard/patientmonitoring/diagnosticreports/view",
          },
        ],
      },
      {
        title: "Forms",
        path: "/dashboard/forms",
        //         icon: ICONS.forms,
        icon: <AssignmentIcon />,
        children: [
          { title: "Forms List", path: "/dashboard/forms/formslist" },
          { title: "All Forms", path: "/dashboard/forms/allforms" },
          { title: "Assign Forms", path: "/dashboard/forms/assignforms" },
        ],
      },
      {
        title: "Email",
        path: "/dashboard/email",
        //         icon: ICONS.email,
        icon: <MailOutlineIcon />,
        children: [
          { title: "Send Email", path: "/dashboard/email/sendemail" },
          { title: "Send Bulk Email", path: "/dashboard/email/sendbulkemail" },
          { title: "Email Log", path: "/dashboard/email/emaillog" },
          { title: "Email Setting", path: "/dashboard/email/emailsettings" },
          { title: "Email Template", path: "/dashboard/email/emailtemplate" },
        ],
      },
      /* 
      {
        title: 'Setting',
        path: '/dashboard/setting',
        icon: ICONS.setting,
        children: [
          { title: 'System Info', path: '/dashboard/setting/systeminfo' },
          { title: 'Taxes', path: '/dashboard/setting/taxes' },
          { title: 'Payment Methods', path: '/dashboard/setting/paymentmethods' },
          { title: 'Payment Gateway', path: '/dashboard/setting/paymentgateway' },
          { title: 'Clinical Notes', path: '/dashboard/setting/clinicalnotes' },
          { title: 'Invoice Items', path: '/dashboard/setting/invoiceitems' },
          { title: 'Expanse Type', path: '/dashboard/setting/expansetype' },
          { title: 'Suppliers', path: '/dashboard/setting/suppliers' },
        ],
      }, */
      // PATIENTS
      {
        title: "My Profile",
        path: "/dashboard/myprofile",
        //         icon: ICONS.myprofile,
        icon: <BadgeIcon />,
      },
      {
        title: "Patient Profile",
        path: "/dashboard/patient-profile",
        //         icon: ICONS.myprofile,
        icon: <BadgeIcon />,
      },
      {
        title: "My Vitals",
        path: "/dashboard/myvitals",
        //          icon: <MonitorHeartOutlinedIcon />,
        icon: <MonitorHeartOutlinedIcon />,
      },
      {
        title: "Patient Vitals",
        path: "/dashboard/patient-vitals",
        //          icon: <MonitorHeartOutlinedIcon />,
        icon: <MonitorHeartOutlinedIcon />,
      },
      // {
      //   title: "My Appointments",
      //   path: "/dashboard/myappointments",
      //   icon: ICONS.appointments,
      // },
      // {
      //   title: "My Care Plan",
      //   path: "/dashboard/mycareplan",
      //   icon: ICONS.careplan,
      // },
      {
        title: "My Health Record",
        path: "/dashboard/myhealthrecord",
        //         icon: ICONS.myhealthrecord,
        icon: <FeedOutlinedIcon />,
      },
      {
        title: "My Health Record",
        path: "/dashboard/myhealthrecord",
        icon: <FeedOutlinedIcon />,
        children: [
          // {
          //   title: "Questionnnaires Assignment",
          //   path: "/dashboard/myhealthrecord/questionnairesassignment",
          // },
          // { title: "TMP Graph", path: "/dashboard/myhealthrecord/mygraphs" },
          {
            title: "Completed Forms",
            path: "/dashboard/myhealthrecord/myhistory",
          },
          {
            title: "Assigned Forms",
            path: "/dashboard/myhealthrecord/questionnaires",
          },
          {
            title: "HAMP",
            path: "/dashboard/myhealthrecord/hamp",
          },
        ],
      },
      {
        title: "Patient's Health Record",
        path: "/dashboard/patient-healthrecord",
        icon: <FeedOutlinedIcon />,
        children: [
          // {
          //   title: "Questionnnaires Assignment",
          //   path: "/dashboard/myhealthrecord/questionnairesassignment",
          // },
          // { title: "TMP Graph", path: "/dashboard/myhealthrecord/mygraphs" },
          {
            title: "Assigned Forms",
            path: "/dashboard/patient-healthrecord/questionnaires",
          },
          {
            title: "Completed Forms",
            path: "/dashboard/patient-healthrecord/patient-history",
          },
        ],
      },
      // Insurance
      {
        title: "Validation",
        path: "/dashboard/validation",
        icon: <AssignmentTurnedInOutlinedIcon />,
      },
      // {
      //   title: "Remove Appointments",
      //   path: "/dashboard/appointments",
      //   icon: ICONS.removeappointments,
      // },
      //Programs Section
      {
        title: "Programs",
        path: "/dashboard/programforms",
        icon: <AssessmentIcon />,
        //         icon: ICONS.programs,
      },
    ],
  },
];

export default sidebarConfig;

// PATINET
//myprofile
//myvitals
//myappointments
//mycareplan
//myhealthrecord

// INSURANCE
//validation
//removeappoinments
